<template>
  <div class="community-post-composer">
    <rich-text-editor
      v-model="text"
      placeholder="Compartilhe algo com a comunidade..."
    />

    <div v-if="image" class="composer-image mt-2">
      <img :src="image" alt="" />
      <button type="button" class="btn-remove-image" @click="image = null">
        Remover imagem
      </button>
    </div>

    <div
      class="composer-actions d-flex align-items-center justify-content-between mt-2"
    >
      <input-image id="composer-image" v-model="image">
        <span class="btn-attach">
          <i class="icon-image" /> Adicionar imagem
        </span>
      </input-image>

      <button
        class="btn btn-primary px-4"
        :disabled="loading || !canSubmit"
        @click="submit"
      >
        <loading :show="loading" small>Publicar</loading>
      </button>
    </div>
  </div>
</template>

<script>
import InputImage from "@/components/InputImage.vue";
import RichTextEditor from "./RichTextEditor.vue";

export default {
  name: "PostComposer",
  components: { InputImage, RichTextEditor },
  props: {
    communityId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      text: "",
      image: null,
      loading: false
    };
  },
  computed: {
    canSubmit() {
      return !!(this.text && this.text.trim()) || !!this.image;
    }
  },
  methods: {
    submit() {
      if (!this.canSubmit) return;
      this.loading = true;
      this.$store
        .dispatch("community/createPost", {
          id: this.communityId,
          text: this.text,
          image: this.image
        })
        .then(post => {
          this.$message.success("Publicação criada");
          this.text = "";
          this.image = null;
          this.$emit("created", post);
        })
        .catch(error => {
          const message =
            error?.response?.data?.non_field_errors?.[0] ||
            "Não foi possível publicar";
          this.$message.error(message);
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.community-post-composer {
  padding: 16px;
  border-radius: 12px;
  border: 1px solid rgba(128, 128, 128, 0.2);

  .composer-image {
    position: relative;
    display: inline-block;

    img {
      max-width: 100%;
      max-height: 240px;
      border-radius: 8px;
    }

    .btn-remove-image {
      display: block;
      margin-top: 4px;
      border: none;
      background: transparent;
      color: #ff757e;
      font-size: 12px;
      padding: 0;
    }
  }

  .btn-attach {
    display: inline-flex;
    align-items: center;
    font-size: 14px;

    i {
      font-size: 18px;
      margin-right: 6px;
    }
  }
}
</style>
